import { Breadcrumbs, Grid, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { preventDefaultClickFunction } from '../../../../utility/helpers/commonFunction';

const RecordPaymentListHeader = ({ showCustomerName = false, customerDetail }) => {
    return (
        <Grid container gap={'8px'}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <div role="presentation" onClick={preventDefaultClickFunction}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/invoice/all" style={{ color: 'rgba(0,0,0,0.60)', textDecoration: 'none' }}>
                            Invoices
                        </Link>
                        <Link style={{ color: 'rgba(0,0,0,0.60)', textDecoration: 'none' }}>Record Payment</Link>
                    </Breadcrumbs>
                </div>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <Typography variant="h4" sx={{ fontWeight: '500' }}>
                    Record Payment{showCustomerName ? ` - ${customerDetail?.firstName} ${customerDetail?.lastName}` : ''}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default RecordPaymentListHeader;
